export default function assetLoaded() {
  return {
    loaded: false,

    init() {
      const el  = this.$el;
      const tag = el.tagName;

      const markLoaded = () => { this.loaded = true; };

      if (tag === 'IMG') {
        if (el.complete) {
          this.loaded = true;
          return;
        }
        el.addEventListener('load', markLoaded, { once: true });
      }

      else if (tag === 'VIDEO') {
        if (el.readyState >= 2) { // HAVE_CURRENT_DATA
          this.loaded = true;
          return;
        }
        el.addEventListener('loadeddata', markLoaded, { once: true });
      }

      else {
        this.loaded = true;
      }
    },
  };
}
